var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ServicesCard',{attrs:{"cardHeadline":"Oversikt over dine saker"},model:{value:(_vm.services),callback:function ($$v) {_vm.services=$$v},expression:"services"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }